<template>
  <div class="sidebar" :class="{ collapsed: collapsed }" :style="{ width: sidebarWidth }">
    <!-- toggle -->
    <div class="text-center">
      <i
          class="bi bi-text-indent-left h2 toggle-icon rotate-180"
          :style="{ transform: collapsed ? 'rotate(180deg)' : 'rotate(0deg)' }"
          @click="toggleSidebar"
      />
    </div>

    <div v-for="(items, section) in groupedMenu" :key="section">

      <!-- SECTION -->
      <div class="menu-section" v-if="section">
        <span v-if="!collapsed">
          {{ formatSection(section) }}
        </span>
      </div>

      <!-- ITEMS -->
      <div
          v-for="(row, index) in items"
          :key="index"
          class="text-center"
      >
        <SidebarLink
            :to="row.path"
            :icon="row.icon || ''"
            @click="handleClick"
        >
          {{ row.name ? $t(row.name) : $t(row.title) }}
        </SidebarLink>

        <!-- SUBMENU -->
        <Transition name="fade">
          <ul
              v-show="!collapsed && activeParent === row.path && getSubmenu(row.path).length"
              class="submenu"
          >
            <li v-for="subel in getSubmenu(row.path)" :key="subel.name">
              <SidebarLink
                  :to="{ name: subel.name }"
                  icon=""
                  @click="handleClick"
              >
                {{ $t(subel.name) }}
              </SidebarLink>
            </li>
          </ul>
        </Transition>

      </div>
    </div>

    <!-- logout -->
    <div class="collapse-icon pb-5 text-center">
      <a class="link" href="#" @click.prevent="logout">
        <i class="bi bi-door-closed icon h5"></i>
        <span v-if="!collapsed" class="menu-text">
          {{ $t('user.logout') }}
        </span>
      </a>
    </div>

  </div>
</template>

<style src="./Sidebar.scss" lang="scss" />
<script src="./Sidebar.js"></script>
